import React from 'react';
import { ChevronDown } from 'lucide-react';

interface Option {
  value: string;
  label: string;
}

interface Props {
  options: Option[];
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  id?: string;
  name?: string;
  disabled?: boolean;
  fullWidth?: boolean;
  className?: string;
  'aria-label'?: string;
}

const Select: React.FC<Props> = ({
  options,
  value,
  onChange,
  placeholder,
  id,
  name,
  disabled,
  fullWidth = false,
  className = '',
  'aria-label': ariaLabel,
}) => {
  return (
    <div className={`relative ${fullWidth ? 'w-full' : 'inline-block'}`}>
      <select
        id={id}
        name={name}
        value={value}
        disabled={disabled}
        aria-label={ariaLabel}
        onChange={(e) => onChange(e.target.value)}
        className={[
          'h-11 w-full appearance-none rounded-lg border border-slate-300 bg-white pl-3.5 pr-9 text-base text-slate-900',
          'focus:border-brand-600 focus:outline-none focus:ring-2 focus:ring-brand-600/20',
          'disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-slate-500',
          className,
        ].join(' ')}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      <ChevronDown
        aria-hidden
        className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-500"
      />
    </div>
  );
};

export default Select;
